module.exports = __webpack_public_path__ + "assets/img/fb645b88630a1a3273d68df1a6fa9f50.png";